import { render } from "./CustomerAdd.vue?vue&type=template&id=10bf2e6a&scoped=true"
import script from "./CustomerAdd.vue?vue&type=script&lang=js"
export * from "./CustomerAdd.vue?vue&type=script&lang=js"

import "./CustomerAdd.vue?vue&type=style&index=0&id=10bf2e6a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10bf2e6a"]])

export default __exports__